import React from "react";
import { Col, Row } from "reactstrap";
import { object } from "prop-types";
import moment from "moment";
import "./singleClientReportDetailsTable.css";
import { SmallLogo } from "../../../../../assets";
import { getRiskColor } from "../../../../../utilities/riskColor";

const SingleClientReportDetailsTable = ({ singleClientReportDetails }) => {
  return (
    <div className="single-client-report-table-main-container">
      <div className="single-client-report-table-title">
        <SmallLogo />
        {singleClientReportDetails.singleClientReportLabel}
      </div>

      <Row className="single-client-report-table-data">
        <Col lg={6} className="p-0">
          <DataEntry
            nameLabel={singleClientReportDetails.clientNameLabel}
            valueLabel={singleClientReportDetails.clientName}
          />
          <DataEntry
            nameLabel={singleClientReportDetails.egnUncLabel}
            valueLabel={singleClientReportDetails.egnUnc}
          />
          <DataEntry
            nameLabel={singleClientReportDetails.offerIdLabel}
            valueLabel={singleClientReportDetails.offerId}
          />
          <DataEntry
            colored
            nameLabel={singleClientReportDetails.riskClassLabel}
            valueLabel={singleClientReportDetails.riskClass}
          />
        </Col>
        <Col lg={6} className="p-0">
          <DataEntry
            nameLabel={singleClientReportDetails.dateOfLastScoringLabel}
            valueLabel={
              singleClientReportDetails.dateOfLastScoring === null
                ? "N/A"
                : moment
                    .utc(singleClientReportDetails.dateOfLastScoring)
                    .local()
                    .format("DD.MM.YYYY HH:mm:ss")
            }
          />
          <DataEntry
            nameLabel={singleClientReportDetails.dateOfLastWatchlistCheckLabel}
            valueLabel={
              singleClientReportDetails.dateOfLastWatchlistCheck === null
                ? "N/A"
                : moment
                    .utc(singleClientReportDetails.dateOfLastWatchlistCheck)
                    .local()
                    .format("DD.MM.YYYY HH:mm:ss")
            }
          />

          <DataEntry
            nameLabel={singleClientReportDetails.clientStatusLabel}
            valueLabel={singleClientReportDetails.clientStatus}
          />
          <DataEntry
            nameLabel={singleClientReportDetails.scoringDecisionLabel}
            valueLabel={singleClientReportDetails.scoringDecision}
          />
        </Col>
      </Row>
      <Row className="single-client-report-table-data">
        {singleClientReportDetails.negativeMediaDataList.map((nmd, i) => {
          return (
            <Col lg={6} className="p-0">
              <React.Fragment>
                <DataEntry
                  nameLabel={nmd.negativeMediaPresenceLabel}
                  valueLabel={nmd.negativeMediaPresence}
                />

                {nmd.negativeMediaOfficerDecision === null ? null : (
                  <DataEntry
                    nameLabel={nmd.negativeMediaOfficerDecisionLabel}
                    valueLabel={nmd.negativeMediaOfficerDecision}
                  />
                )}
                {nmd.negativeMediaUrl === null ? null : (
                  <DataEntry
                    nameLabel={nmd.negativeMediaUrlLabel}
                    valueLabel={
                      <a target="_blank" href={nmd.negativeMediaUrl}>
                        {nmd.negativeMediaUrlDisplay}
                      </a>
                    }
                  />
                )}
              </React.Fragment>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

function DataEntry({ nameLabel = "", valueLabel = "", colored = false }) {
  const valueClassName = () =>
    colored ? { color: getRiskColor({ key: valueLabel }) } : {};

  return (
    <div className="data-entry-box">
      <div className="data-entry-name font-weight-bolder">{nameLabel}</div>
      <div style={valueClassName()}>{valueLabel}</div>
    </div>
  );
}

SingleClientReportDetailsTable.propTypes = {
  singleClientReportDetails: object.isRequired,
};

export default SingleClientReportDetailsTable;



// WEBPACK FOOTER //
// ./src/features/reports/components/single-client-details/client-info-table/SingleClientReportDetailsTable.jsx